import React from 'react';
import AddAddressDrawer from "../AddAddressDrawer";
import EditAddress from "../EditAddress";
import EditAccount from "../EditAccount";
import AddAccountDrawer from "../AddAccountDrawer";
import moment from "moment";
import AgencyForm from '../Registration/AgencyForm';
import LicensesDocuments from '../LicensesDocuments';
import UserAddress from "../UserAddress"
import UserAccount from '../UserAccount';
import {
    Layout, Menu, Spin, Row, Col, Button, message, Modal, Form
} from 'antd';
import MiCompAPI from '../../../util/api';
const { Content } = Layout;
class Agency extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            currentTab: 'general',
            personalDetailsEditable: false,
            addressEditable: false,
            addAddressActive: false,
            agencydata: null,
            defaultActiveKey: "1",
            address_types: [],
            states: [],
            act_types: [],
            lob: [],
            addAccountActive: false,
            accountEditable: false,
        }

        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.signUpForm = Form.create()(AgencyForm);

        this.getAgencyDetails();
        this.getClientMasters();
    }
    addAccountDefaultHandler = () => {
        this.setState({ addAccountActive: !this.state.addAccountActive });
    };
    addAddressDefaultHandler = () => {
        this.setState({ addAddressActive: !this.state.addAddressActive });
    };
    removeAccount = (acc_id) => {
        this.api.invoke(
            "DeleteAccount/" + acc_id,
            "patch",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.getAgencyDetails();
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    addAccountSubmitHandler = (data, callback) => {
        message.loading("Account Address..", 0);
        this.api.invoke(
            "SaveandUpdateAccount",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.setState({ addAccountActive: false });
                        this.getAgencyDetails();
                        callback(true);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                        callback(false);
                    }
                } else {
                    message.destroy();
                    message.error("Add Account failed. Contact Support", 3);
                    callback(false);
                }
            },
            { ...data, acc_Number: data.acc_Number.toString() }
        );
    };

    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        address_types: data.address_types,
                        states: data.states,
                        act_types: data.account_types,
                        lob: data.lobs,
                    });
                }
            },
            ["LOB", "ADDRESS_TYPE", "STATE", "ACCOUNT_TYPE"]
        );
    }
    getAgencyDetails = (state_updates = {}) => {
        this.setState({ isLoading: true });
        this.api.invoke("MyAgencyProfileGetById/0", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    this.setState({ ...state_updates, agencydata: data.data, isLoading: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }

    handleClick = (e) => {
        this.setState({
            currentTab: e.key,
        });
    }
    handleEditSubmit = (data) => {

        this.api.invoke("AgencyDetailsUpdate", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                    this.setState({
                        personalDetailsEditable: !this.state.personalDetailsEditable,
                    });
                    this.getAgencyDetails();
                } else {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                }
            }
            else {
                message.destroy();
                message.error("Failed to update Personal Details. Contact Support", 3);
            }
        }, data);

    }
    handleEditStatus = (type) => {
        if (type === "primary_contact_details")
            this.setState({
                primaryContactDetailsEditable: !this.state.primaryContactDetailsEditable
            });
        else if (type === "address")
            this.setState({
                addressEditable: !this.state.addressEditable
            });
        else if (type === "account") {
            this.setState({
                accountEditable: !this.state.accountEditable,
            });
        }
    }
    addAddressDefaultHandler = () => {
        this.setState({ addAddressActive: !this.state.addAddressActive });
    };
    addAddressSubmitHandler = (data, callback) => {
        data = {
            id: data.id,
            address_Type_Id: data.address_type,
            street: data.street,
            street1: data.street1,
            zipCode: data.zip,
            stateID: data.state,
            city: data.city,
            isprimaryAcc: data.isprimaryAcc,
        };
        message.loading("Adding Address..", 0);
        this.api.invoke(
            "PersonalAddressUpsert",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.setState({ addAddressActive: false });
                        this.getAgencyDetails();
                        callback(true);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                        callback(false);
                    }
                } else {
                    message.destroy();
                    message.error("Add address failed. Contact Support", 3);
                    callback(false);
                }
            },
            data
        );
    };


    removeAdderss = (address_id) => {
        this.api.invoke(
            "RemovePersonalAddress/" + address_id,
            "delete",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.getAgencyDetails();
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                } else {
                    message.destroy();
                    message.error("Remove address failed. Contact Support", 3);
                }
            }
        );
    }

    getSelectedTabView() {
        if (this.state.isLoading) {
            return (
                <div className="mi_main" style={{ textAlign: 'center' }}>
                    <Spin size="large" />
                </div>
            );
        }
        switch (this.state.currentTab) {
            case "general":
                {
                    let primaryContactDetailsCard, addressCard;
                    if (this.state.primaryContactDetailsEditable) {
                        primaryContactDetailsCard = (
                            <div className="mi_main">
                                <Row span={24}>
                                    <Col span={15}>
                                        <p className='mi_title' style={{ color: '#fd828d' }}>              Company Details  </p>
                                    </Col>
                                    <Col span={9}>
                                        <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "primary_contact_details")} > <i className="fa fa-times mi_icon mi_icon_red" ></i></Button>
                                    </Col>
                                </Row>
                                <this.signUpForm lob={this.state.lob} states={this.state.states} isexistprofile={true} data={this.state.agencydata.agency} id={this.state.agencydata.agency.user_Id} submitHandler={this.handleEditSubmit} />


                            </div>
                        );
                    }
                    else {
                        primaryContactDetailsCard = (
                            <div className="mi_main">
                                <Row span={24}>
                                    <Col span={15}>
                                        <p className='mi_title' style={{ color: '#fd828d' }}> Company Details  </p>
                                    </Col>
                                    <Col span={9}>
                                        <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "primary_contact_details")} > <i className="fa fa-pencil mi_icon" /></Button>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5} sm={24}>
                                        <p className="mi_name">Company Name</p>
                                        <p className="mi_value">{this.state.agencydata.agency.agency_Name ? this.state.agencydata.agency.agency_Name : 'none'}</p>
                                    </Col>
                                    <Col md={4} sm={24}>
                                        <p className="mi_name">Primary Contact Name</p>
                                        <p className="mi_value">{
                                            (this.state.agencydata.agency.primary_Contact_Last_Name ? this.state.agencydata.agency.primary_Contact_Last_Name : "") + " " + (this.state.agencydata.agency.primary_Contact_Middle_Name ? this.state.agencydata.agency.primary_Contact_Middle_Name : "") + " " + (this.state.agencydata.agency.primary_Contact_First_Name ? this.state.agencydata.agency.primary_Contact_First_Name : "")
                                        }</p>
                                    </Col>


                                    <Col md={5} sm={24}>
                                        <p className="mi_name">Primary Contact Email Address</p>
                                        <p className="mi_value">{this.state.agencydata.agency.primary_Contact_Email ? this.state.agencydata.agency.primary_Contact_Email : 'none'}</p>
                                    </Col>
                                    <Col md={4} sm={24}>
                                        <p className="mi_name">Primary Contact Number</p>
                                        <p className="mi_value">
                                            {this.state.agencydata.agency.primary_Contact_Phone && this.state.agencydata.agency.primary_Contact_Phone.length === 17 ? <a href={"tel:+" + this.state.agencydata.agency.primary_Contact_Phone}>{this.state.agencydata.agency.primary_Contact_Phone}</a> : "Invalid US Number"}
                                        </p>
                                    </Col>
                                    <Col md={3} sm={24}>
                                        <p className="mi_name">TAX Id</p>
                                        <p className="mi_value"> {this.state.agencydata.agency.tax_Id ? this.state.agencydata.agency.tax_Id : 'none'}</p>
                                    </Col>
                                    <Col md={3} sm={24}>
                                        <p className="mi_name">NPN</p>
                                        <p className="mi_value"> {this.state.agencydata.agency.npn ? this.state.agencydata.agency.npn : 'none'}</p>
                                    </Col>
                                </Row>

                            </div>
                        );
                    }
                    if (this.state.addressEditable) {
                        addressCard = (
                            <div className="mi_main">
                                <Row span={24}>
                                    <Col span={15}>
                                        <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
                                    </Col>
                                    <Col span={9}>
                                        <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "address")}   > {this.state.addressEditable ?
                                            <i className="fa fa-times mi_icon mi_icon_red" />
                                            :
                                            <i className="fa fa-pencil mi_icon" />}
                                        </Button>
                                        <Button className="mi_button_icon" onClick={this.addAddressDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                                    </Col>
                                </Row>


                                {this.state.agencydata.addresses
                                    ? this.state.agencydata.addresses.map((item) => {
                                        return (<div>
                                            <p className='mi_address_card'>{item.address_Type_Name}</p>
                                            <EditAddress item={item} states={this.state.states} removeAdderss={this.removeAdderss} submitHandler={this.addAddressSubmitHandler}></EditAddress>
                                        </div>
                                        );
                                    }) : ''}
                            </div>
                        );
                    }
                    else {
                        addressCard = (
                            <div className="mi_main">
                                <Row span={24}>
                                    <Col span={15}>
                                        <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
                                    </Col>
                                    <Col span={9}>
                                        <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "address")}   > {this.state.addressEditable ?
                                            <i className="fa fa-times mi_icon mi_icon_red" />
                                            :
                                            <i className="fa fa-pencil mi_icon" />}
                                        </Button>
                                        <Button className="mi_button_icon" onClick={this.addAddressDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                                    </Col>
                                </Row>
                                <UserAddress address={this.state.agencydata.addresses}></UserAddress>
                            </div>
                        );
                    }
                    return (
                        <div>

                            <Row span={24}>
                                <Col span={24}>
                                    {primaryContactDetailsCard}
                                </Col>
                            </Row>

                            <Row span={24}>

                                <Col span={24}>
                                    {addressCard}
                                </Col>
                            </Row>

                            <div className="mi_main">
                                <p className='mi_title' style={{ color: '#fd828d' }}>Other Details</p>
                                <Row span={24}>
                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Agency Id</p>
                                        <p className="mi_value">{this.state.agencydata.agency.id ? this.state.agencydata.agency.id : 'none'}</p>
                                    </Col>

                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Created Date </p>
                                        <p className="mi_value">{this.state.agencydata.agency.createdOn ? moment(this.state.agencydata.agency.createdOn).format("MM/DD/YYYY") : 'none'}</p>
                                    </Col>

                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Last Update Date</p>
                                        <p className="mi_value">{this.state.agencydata.agency.updatedOn ? moment(this.state.agencydata.agency.updatedOn).format("MM/DD/YYYY") : 'none'}</p>
                                    </Col>
                                </Row>
                            </div>
                        </div>);
                }
            case "licenses":
                {

                    return (
                        <div>
                            <LicensesDocuments {...this.props} User_Id={this.state.agencydata&&this.state.agencydata.agency.user_Id} lname={ this.state.agencydata&&this.state.agencydata.agency.primary_Contact_Last_Name}  userPermandMasters={this.props.userPermandMasters} iswrite={true} isLoading={this.state.isLoading} documents={this.state.agencydata.documents} licenses={this.state.agencydata.licenses}></LicensesDocuments>

                        </div>
                    );
                }
            case "act": {
                let accountCard;
                if (this.state.accountEditable) {
                    accountCard = (
                        <div className="mi_main">
                            <Row span={24}>
                                <Col span={18}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Account Information</p>
                                </Col>
                                <Col span={6}>
                                    <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "account")} > <i className="fa fa-times mi_icon mi_icon_red" ></i></Button>
                                </Col>
                            </Row>
                            {this.state.agencydata.agency_Accounts
                                ? this.state.agencydata.agency_Accounts.map((item) => {
                                    return (<div>
                                        <p className='mi_address_card'>{item.account_Type_Name}</p>
                                        <EditAccount item={item} removeAdderss={this.removeAccount} submitHandler={this.addAccountSubmitHandler}></EditAccount>
                                    </div>);
                                }) : ''}
                        </div>
                    );
                } else {
                    accountCard = (
                        <div className="mi_main">
                            <Row span={24}>
                                <Col span={15}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Account Information</p>
                                </Col>
                                <Col span={9}>
                                    <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "account")}   ><i className="fa fa-pencil mi_icon" /></Button>
                                    <Button className="mi_button_icon" onClick={this.addAccountDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                                </Col>
                            </Row>
                            <UserAccount accounts={this.state.agencydata.agency_Accounts}></UserAccount>

                        </div>
                    );
                }
                return (
                    <Row span={24}>
                        <Col md={24} sm={24}>
                            {accountCard}
                        </Col>
                    </Row>
                );
            }
            default:
                break
        }
    }
    render() {
        return (
            <Content>
                {this.state.addAddressActive ? (
                    <Modal
                        visible={this.state.addAddressActive}>
                        <AddAddressDrawer
                            closeDrawerHandler={this.addAddressDefaultHandler}
                            submitHandler={this.addAddressSubmitHandler}
                            width={500}
                            address_types={this.state.address_types}
                            states={this.state.states}
                            userPermandMasters={this.props.userPermandMasters}
                            title="Enter New Address Details"
                        />
                    </Modal>
                ) : null}
                {this.state.addAccountActive ? (
                    <Modal
                        visible={this.state.addAccountActive}
                    >
                        <AddAccountDrawer
                            closeDrawerHandler={this.addAccountDefaultHandler}
                            submitHandler={this.addAccountSubmitHandler}
                            width={500}
                            act_types={this.state.act_types}
                            userPermandMasters={this.props.userPermandMasters}
                            title="Enter New Agency Account"
                        />
                    </Modal>
                ) : null}


                <div className="mi_main_div">
                    <Menu className='mi_general_bar' style={{  width: 'fit-content'}}
                        onClick={this.handleClick}
                        selectedKeys={[this.state.currentTab]}
                        mode="horizontal"
                    >
                        <Menu.Item className="mi_menu_item" key="general">
                            General
                        </Menu.Item>
                        <Menu.Item className="mi_menu_item" key="licenses" >
                            Compliance
                        </Menu.Item>
                        <Menu.Item className="mi_menu_item" key="act">
                            Billing
                        </Menu.Item>
                    </Menu>
                    {this.getSelectedTabView()}
                </div>
            </Content>
        );
    }
}
export default Agency;